import { Text, Badge } from '@chakra-ui/react';

import { formatSimpleValue } from '../utils/fieldFormatting';
import DataTableCard from './DataTableCard';
import ValidationBadge from './ValidationBadge';

interface MaritalStatusCardProps {
  data?: any;
}

const MaritalStatusCard = ({ data }: MaritalStatusCardProps) => {
  // Get processed data
  const driverRows = data?.driverRows || [];

  const formatMaritalStatus = (status: string) => {
    const statusMap: { [key: string]: string } = {
      S: 'Single',
      M: 'Married',
      D: 'Divorced',
      W: 'Widowed',
    };

    const displayStatus = statusMap[status] || status || 'Not specified';

    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {displayStatus}
      </Badge>
    );
  };

  const formatDisplayValue = (value: string) => {
    return value && value.trim() !== '' ? (
      formatSimpleValue(value)
    ) : (
      <Text color="gray.400" fontStyle="italic" fontSize="sm">
        Not provided
      </Text>
    );
  };

  const formatSpouseInfo = (row: any) => {
    const hasSpouseInfo =
      (row.spouseName && row.spouseName.trim() !== '') ||
      (row.spouseLicenseNumber && row.spouseLicenseNumber.trim() !== '') ||
      (row.spouseCompany && row.spouseCompany.trim() !== '') ||
      (row.spousePolicyNumber && row.spousePolicyNumber.trim() !== '') ||
      (row.spouseExpiryDate && row.spouseExpiryDate.trim() !== '');

    if (!hasSpouseInfo) {
      return (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      );
    }

    const parts = [];
    if (row.spouseName && row.spouseName.trim() !== '') {
      parts.push(`Name: ${row.spouseName}`);
    }
    if (row.spouseLicenseNumber && row.spouseLicenseNumber.trim() !== '') {
      parts.push(`License: ${row.spouseLicenseNumber}`);
    }
    if (row.spouseCompany && row.spouseCompany.trim() !== '') {
      parts.push(`Company: ${row.spouseCompany}`);
    }
    if (row.spousePolicyNumber && row.spousePolicyNumber.trim() !== '') {
      parts.push(`Policy: ${row.spousePolicyNumber}`);
    }
    if (row.spouseExpiryDate && row.spouseExpiryDate.trim() !== '') {
      parts.push(`Expiry: ${row.spouseExpiryDate}`);
    }

    return parts.map((part, index) => (
      <Text key={index} fontSize="sm">
        {part}
      </Text>
    ));
  };

  const headers = ['Driver', 'Marital Status', 'Spouse Information', 'Outcome'];

  const rows = driverRows.map((row: any) => [
    formatDisplayValue(row.driverName),
    formatMaritalStatus(row.maritalStatus),
    formatSpouseInfo(row),
    row.isValid ? (
      <ValidationBadge status="pass" />
    ) : (
      <ValidationBadge status="caution" />
    ),
  ]);

  return (
    <DataTableCard
      description="Check to account for any spouses not listed on application."
      headers={headers}
      rows={rows}
    />
  );
};

export default MaritalStatusCard;
